import { AnalyticsEvent, GTMEventData } from "@hermes/utils/analytics";

/**
 * This class is used for product-click event in grid page
 */
export class GridDisplayModeEvent implements AnalyticsEvent<GTMEventData> {
    public name: string = "uaevent";

    /**
     * Event's data from component to format correctly event
     */
    public eventData: { displayMode: string };

    constructor(data: { displayMode: string }) {
        this.eventData = data;
    }
    /**
     * Overload formatForGTM of inherited class
     * Return formatter for ecommerce key
     */
    public formatForGTM(): GTMEventData {
        return {
            event: this.name,
            eventcategory: "Product_Grid",
            eventaction: "DisplayMode",
            eventlabel:
                this.eventData.displayMode === "grid"
                    ? "Display_grid"
                    : "Display_list",
        };
    }
}
